import { AccommodationIcon, MainDetailsIcon } from '~/svgs';

import { Translate } from '~/i18n';

export const DhamenRequestsNavigationLinks = [
   {
      id: 0,
      href: '/:id/edit/supervisor-and-arrival-details',
      text: <Translate id="visasManager:supervisor details" />,
      required_form_field: 'name',
      icon: <MainDetailsIcon />,
   },
   {
      id: 1,
      href: '/:id/edit/accommodation-details',
      text: <Translate id="visasManager:accommodation details" />,
      required_form_field: 'accomodations',
      icon: <AccommodationIcon />,
   },
   {
      id: 2,
      href: '/:id/edit/additional-services',
      text: <Translate id="visasManager:additional services" />,
      required_form_field: 'tripServices',
      icon: <MainDetailsIcon />,
   },
];

export const AddApplicantNavigationLinks = [
   {
      id: 0,
      href: '/:id/add-applicant/:applicationNo/edit/applicant-information',
      text: <Translate id="visasManager:applicant information" />,
      required_form_field: 'nationality',
      icon: <MainDetailsIcon />,
   },
   {
      id: 1,
      href: '/:id/add-applicant/:applicationNo/edit/visa-information',
      text: <Translate id="visasManager:visa information" />,
      required_form_field: 'passportNo',
      icon: <MainDetailsIcon />,
   },
   {
      id: 2,
      href: '/:id/add-applicant/:applicationNo/edit/additional-documents',
      text: <Translate id="visasManager:additional documents" />,
      required_form_field: 'iqamaId',
      icon: <MainDetailsIcon />,
   },
   {
      id: 3,
      href: '/:id/add-applicant/:applicationNo/edit/more-information',
      text: <Translate id="visasManager:more information" />,
      required_form_field: 'mofaquestionnaire',
      icon: <MainDetailsIcon />,
   },
];
